module.exports = __webpack_public_path__ + "img/crosschain_dark.598c195e.svg";